$shm_hitalama_map_widget_float_code $shm_hitalama_map_widget_float
	tools_custom /
		<= Font_size_tool $shm_hitalama_map_fontsize
			font_size? <=> font_size? 16
	code_head /
		<= Widget_title_edit $mol_string_button
			value? <=> title?
		<= Code_panel $shm_hitalama_map_widget_float_code_panel
			no_crdt <= no_crdt false
			code_download_blob <= code_download_blob null
			code_download_file_name <= code_download_file_name \
			template_dictionary <= template_dictionary *
			template_selected? <=> template_selected? \
			enabled? <=> enabled? true
			run_click? <=> run_click? null
	controls /
		<= Code_head $mol_view
			sub <= code_head
		^ code_content /
			<= Textarea $shm_hitalama_map_widget_float_code_textarea
				lazy_enabled <= textarea_lazy_enabled true
				hint <= textarea_hint \
				sidebar_showed true
				value? <=> code? \
				value_click*? <=> widget_value_click*? null
				spellcheck false
				submit <= run_click
				style *
					^
					fontSize <= font_size_px
			<= Bench $shm_hitalama_map_widget_float_code_bench
				widget <= widget
				map <= map
				Map_page <= Map_page
				run_click <= run_click null
	contextmenu_body /
		^
		^ disable_crdt_visible / <= Disable_crdt $mol_button_minor
			title \Отключить CRDT
			click? <=> disable_crdt? null
